export const REFERRAL_COOKIE = 'outpoll_ref';
export const REFERRAL_PARAM = 'ref';
export const REFERRAL_COOKIE_MAX_AGE = 30 * 24 * 60 * 60;
const REFERRAL_CODE_PATTERN = /^[A-Za-z0-9_-]{4,15}$/;
const REFERRAL_CODE_EVENT = 'referralcodechange';

export function isValidReferralCode(code: string | null | undefined): code is string {
  return !!code && REFERRAL_CODE_PATTERN.test(code);
}

/** Reads the pending referral code from the cookie. */
export function getReferralCode(): string {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(new RegExp(`(?:^|; )${REFERRAL_COOKIE}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : '';
}

/** Stores the referral code in a cookie and notifies same-tab subscribers. */
export function saveReferralCode(code: string): void {
  if (!isValidReferralCode(code)) return;
  document.cookie = `${REFERRAL_COOKIE}=${code}; Path=/; Max-Age=${REFERRAL_COOKIE_MAX_AGE}; SameSite=Lax`;
  window.dispatchEvent(new Event(REFERRAL_CODE_EVENT));
}

/** Removes the referral code cookie. Safe to call anytime. */
export function clearReferralCode(): void {
  document.cookie = `${REFERRAL_COOKIE}=; Path=/; Max-Age=0`;
  window.dispatchEvent(new Event(REFERRAL_CODE_EVENT));
}

/** Subscribes to same-tab referral code changes. */
export function subscribeReferralCode(onChange: () => void): () => void {
  window.addEventListener(REFERRAL_CODE_EVENT, onChange);
  return () => window.removeEventListener(REFERRAL_CODE_EVENT, onChange);
}

/** Appends `?ref=<code>` to a share URL; returns it untouched when there's no code. */
export function withReferralParam(url: string, code: string | undefined): string {
  if (!isValidReferralCode(code)) return url;
  const parsed = new URL(url);
  parsed.searchParams.set(REFERRAL_PARAM, code);
  return parsed.toString();
}
